import {OptionChainService} from "./OptionChainService";
import {optionGridHeader, OptionGridHeader} from "./popup/grid-header/OptionGridHeaderComponent";
import {optionGrid, OptionGrid} from "./popup/grid/OptionGridComponent";
import {optionGridStrikes, OptionGridStrikes} from "./popup/strikes/OptionGridStrikesComponent";

export default angular.module("tfApp.services.option.chain", [])
                      .service(OptionChainService.id, OptionChainService)
                      .component(OptionGridHeader, optionGridHeader())
                      .component(OptionGrid, optionGrid())
                      .component(OptionGridStrikes, optionGridStrikes())
                      .name;
